import React, { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { reverseUrl } from '../../../navigation/reverseUrl'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { AvatarInner } from '../../common/Avatar'
import { Icon, IconChoices } from '../../common/Icon'
import { PersonRow } from '../../../generated/api/people-page'

interface PersonListItemProps {
  person: PersonRow
  societyId: string
  index: number
}

export const PersonListItem = ({
  person,
  societyId,
  index,
}: PersonListItemProps): ReactNode => {
  const navigate = useNavigate()
  const { translate } = useAppTranslation()
  const fullName = `${person.firstName} ${person.lastName}`.trim()
  const className = `flex items-center justify-between rounded-lg p-4
      ${index === 0 ? '' : 'border-t border-neutral-90'}
    `

  if (!fullName) {
    return (
      <div className={className}>
        <div className="flex items-center gap-4">
          <AvatarInner />
          <p style={theme.textVariants.baseBold}>
            {translate('common.user.deletedUserName')}
          </p>
        </div>
      </div>
    )
  }

  const navigateToUser = (): void => {
    navigate(reverseUrl('user:society-detail', { id: person.id, societyId }))
  }

  return (
    <button
      onClick={navigateToUser}
      className={`${className} hover:bg-neutral-96`}
    >
      <div className="flex items-center gap-4">
        <AvatarInner
          alt={`${fullName} avatar`}
          url={person.avatarUrl}
          initials={person.initials}
        />
        <p style={theme.textVariants.baseBold} translate="no">
          {fullName}
        </p>
      </div>
      <Icon icon={IconChoices.ARROW} size={26} />
    </button>
  )
}
